// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const KeyValueItem = t.struct({
    key: t.String,
    value: t.String
}, 'KeyValueItem');

export const KeyValueList = t.list(KeyValueItem, 'KeyValueList');
